<template>
  <div class="flex flex-col border p-24 gap-24 rounded">
    <div class="flex flex-row gap-8 items-center">
      <ErrorAlert class="w-16 flex-shrink-0" />
      <Body>
        {{ $t('health_actions.scheduling.select_doctor_no_doctors_found') }}
      </Body>
    </div>
    <div class="flex flex-col gap-8 flex-1">
      <Body class="text-grey-500 font-semibold">
        {{ $t('health_actions.scheduling.select_doctor_distance') }}
      </Body>
      <div class="flex border border-grey-300 rounded p-16">
        <select
          class="w-full justify-between"
          @change="(e) => setDoctorPreferences({ distance: e.target.value })"
        >
          <option value="">
            {{ $t('common.select') }}
          </option>
          <option
            v-for="option in distanceOptions"
            :key="option.value"
            :value="option.value"
            :selected="option.value === getDoctorPreferences.distance"
          >
            {{ option.text }}
          </option>
        </select>
      </div>
    </div>
    <div class="flex flex-col gap-8 flex-1">
      <Body class="text-grey-500 font-semibold">
        {{ $t('health_actions.scheduling.select_doctor_gender') }}
      </Body>
      <div class="flex border border-grey-300 rounded p-16">
        <select
          class="w-full justify-between"
          @change="(e) => setDoctorPreferences({ gender: e.target.value })"
        >
          <option value="">
            {{ $t('common.select') }}
          </option>
          <option
            v-for="option in genderOptions"
            :key="option.value"
            :value="option.value"
            :selected="option.value === getDoctorPreferences.gender"
          >
            {{ option.text }}
          </option>
        </select>
      </div>
    </div>
    <div
      class="flex sm:flex-row flex-col bg-grey-50 rounded-md p-16 justify-between"
    >
      <div class="flex flex-row items-center">
        <InfoCircle class="w-24" />
        <p class="font-sans-bold ml-8">
          {{
            $t('health_actions.scheduling.select_doctor_distance_description')
          }}
          <span class="font-semibold">{{ zipCode }}</span>
        </p>
      </div>
      <p
        class="text-blue-500 font-semibold underline ml-25 pl-1 py-8 cursor-pointer"
        @click="openZipCodeModal"
      >
        {{ $t('health_actions.scheduling.select_doctor_change_zip_code') }}
      </p>
    </div>
    <HMButton rounded="full" class="flex-1 p-16" @click="searchDoctors">
      {{ $t('common.search') }}
    </HMButton>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Body from '~/components/common/Typography/Body.vue'
import { InfoCircle, ErrorAlert } from '~/assets/svgs/index'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import doctorPreferencesMixin from './doctorPreferencesMixin'

export default {
  components: {
    ErrorAlert,
    Body,
    InfoCircle,
  },
  mixins: [screenSizeMixin, doctorPreferencesMixin],
  data() {
    return {
      showChangeZipCodeModal: false,
      newZipCode: '',
    }
  },
  computed: {
    ...mapGetters('scheduling', ['getDoctorPreferences', 'zipCode']),
  },
  methods: {
    ...mapActions('scheduling', [
      'setDoctorPreferences',
      'setZipCode',
      'fetchProviders',
    ]),
    searchDoctors() {
      this.fetchProviders({
        distance: this.getDoctorPreferences.distance,
        providerGender: this.getDoctorPreferences.gender,
        address: this.zipCode,
      })
    },
    openZipCodeModal() {
      console.log('openZipCodeModal no doctors found')
      this.$emit('open-zip-code-modal')
    },
    closeZipCodeModal() {
      this.$emit('close-zip-code-modal')
    },
  },
}
</script>
